import api from './api';
import { getJwt } from '@app/helpers';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

export interface CicloOrcamentarioRelatorio {
  valorTotalA: string;
  valorTotalB: string;
  valorTotalC: string;
  valorTotalD: string;
  valorTotalE: string;
  valorTotalF: string;
  valorTotalG: string;
  valorTotalH: string;

  valorTotalI: string;
  valorTotalJ: string;
  result: CicloOrcamentarioRelatorioResult[];
}

export interface CicloOrcamentarioRelatorioResult {
  saldoCapExDecimal: number;
  aContratarDecimal: number;
  forecastDecimal: number;
  compromissadoDecimal: number;
  requisitadoDecimal: number;
  executadoDecimal: number;
  contratadoDecimal: number;

  capexCicloAnoDecimal: number;
  forecastCicloAnoDecimal: number;
  capExDecimal: number;

  capexCicloAnoRfaDecimal: number;
  forecastCicloAnoRfaDecimal: number;

  diretoriaNome: string;
  diretoria: string;
  area: string;
  areaNome: string;
  departamento: string;
  departamentoNome: string;
  id: string;
  numeroLinha: string;
  nomeprojeto: string;
  planilhaRfaAtual: string;
  codProjeto: string;
  capExp: string;
  contratado: string;
  executado: string;
  requisitado: string;
  compromissado: string;
  aContratar: string;
  forecast: string;
  saldoCapEx: string;
  saldoCapExPercentual: string;
  saldoCapExPercentualCor: string;
}

export interface CicloOrcamentarioProjetoDadosGerais {
  id: string;
  rfa: string;
  statusRfa: string;
  tapAtual: string;
  totvs: string;
  categoria: string;
  orcamentario: string;
  fase: string;
  diretoria: string;
  area: string;
  departamento: string;
  escopo: string;
  requisitosAmbientais: string;
  escopoTab: string;
  inicioBaselineBl: string;
  terminoBaselineBl: string;
  inicioRealFcst: string;
  terminoRealFcst: string;

  inicioBaseline: string;
  terminoBaseline: string;
  inicioRealForecast: string;
  terminoRealForecast: string;

  inicioReal: string;
  terminoReal: string;

  prioridade: string;
  faseTap: string;
  restricaoAmbientalTap: string;
  diligenciamento: string;

  codigo: string;
  nome: string;
  previsto: string;
  dataAprovacaoRfaFormatada: string;
  dataAprovacaoRfa: Date;

  pluriAnual: CicloOrcamentarioProjetoDadosGeraisPluriAnual[];
  anual: CicloOrcamentarioProjetoDadosGeraisAnual[];
}

export interface CicloOrcamentarioProjetoDadosGeraisPluriAnual {
  id: string;
  capEx: string;
  contratado: string;
  executado: string;
  requisitado: string;
  compromissado: string;
  aContratar: string;
  forecast: string;
  saldoCapEx: string;
}

export interface CicloOrcamentarioProjetoDadosGeraisAnual {
  id: string;
  capEx: string;
  contratado: string;
  executado: string;
  requisitado: string;
  compromissado: string;
  aContratar: string;
  forecast: string;
  saldoCapEx: string;
}

export interface CicloOrcamentarioProjetoPacote {
  valorTotalA: string;
  valorTotalB: string;
  valorTotalC: string;
  valorTotalD: string;
  valorTotalE: string;
  valorTotalF: string;
  valorTotalG: string;
  valorTotalH: string;
  result: CicloOrcamentarioProjetoPacoteResult[];
}

export interface CicloOrcamentarioProjetoPacoteResult {
  codPacote: string;
  nomePacote: string;
  orcadoAno: number;
  orcadoAnoFormatado: string;
  contratado: number;
  contratadoFormatado: string;
  executado: number;
  executadoFormatado: string;
  requisitado: number;
  requisitadoFormatado: string;
  compromissado: string;
  aContratar: string;
  forcast: string;
  dataIndex: string;
  ordemInvestimentoCodPacote: string;
  ordemInvestimentoId: string;
  children: CicloOrcamentarioProjetoPacoteResult[];
}

export interface Filtros {
  codigoProjeto: string;
  nomeProjeto: string;
  requisitosAmbientais: string;
  classificaoRfa: string[];
  diretoria: string[];
  area: string[];
  departamento: string[];
  categoria: string[];
  tipo: string[];
  pacoteDisciplina: string[];
  pacoteTipo: string[];
  orcamentario: string[];
  fase: string[];
  trocarValor: boolean;
}

export const getCicloOrcamentarioProjetoDadosGerais = (id: any) =>
  api.get<CicloOrcamentarioProjetoDadosGerais>(
    `relatorioCicloOrcamentario/getCicloOrcamentarioProjetoDadosGerais/${id}`,
  );

export const getCicloOrcamentarioProjetoPacote = (id: any) =>
  api.get<CicloOrcamentarioProjetoPacote>(`relatorioCicloOrcamentario/getCicloOrcamentarioProjetoPacote/${id}`);

export const getCicloOrcamentarioProjetoPacotePluriAnual = (id: any) =>
  api.get<CicloOrcamentarioProjetoPacote>(
    `relatorioCicloOrcamentario/getCicloOrcamentarioProjetoPacotePluriAnual/${id}`,
  );

export const postGetAllRelatorioCicloOrcamentario = (values: Filtros) => {
  return api.post<CicloOrcamentarioRelatorio>(
    'relatorioCicloOrcamentario/postGetAllRelatorioCicloOrcamentario',
    values,
    { disableNotification: 'true' },
  );
};

export const postGetAllRelatorioCicloOrcamentarioPluriAnual = (values: Filtros) => {
  return api.post<CicloOrcamentarioRelatorio>(
    'relatorioCicloOrcamentario/postGetAllRelatorioCicloOrcamentarioPluriAnual',
    values,
    { disableNotification: 'true' },
  );
};

export const postGetAllRelatorioControleRfa = (values: Filtros) => {
  return api.post<CicloOrcamentarioRelatorio>('relatorioCicloOrcamentario/postGetAllRelatorioControleRfa', values, {
    disableNotification: 'true',
  });
};

export const relatorioExportExcel = (values: Filtros) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.post(urlBase + `/api/relatorioCicloOrcamentario/postGetAllRelatorioCicloOrcamentarioExportar`, values, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorioCicloOrcamentarioExportar.xlsx');
      link.setAttribute('id', 'relatorioCicloOrcamentarioExportarId');
      document.body.appendChild(link);
      link.click();
      document.getElementById('relatorioCicloOrcamentarioExportarId').outerHTML = '';
    }),
  );
};

export const getCicloOrcamentarioProjetoPacoteExportaExcel = (id: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/relatorioCicloOrcamentario/getCicloOrcamentarioProjetoPacoteExportaExcel/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorioCicloOrcamentarioPacote.xlsx');
      link.setAttribute('id', 'relatorioCicloOrcamentarioPacoteId');
      document.body.appendChild(link);
      link.click();
      document.getElementById('relatorioCicloOrcamentarioPacoteId').outerHTML = '';
    }),
  );
};

export const getCicloOrcamentarioProjetoPacotePluriAnualExportaExcel = (id: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(
      urlBase + `/api/relatorioCicloOrcamentario/getCicloOrcamentarioProjetoPacotePluriAnualExportaExcel/${id}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      },
    ).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorioCicloOrcamentarioPacotePluriAnual.xlsx');
      link.setAttribute('id', 'relatorioCicloOrcamentarioPacotePluriAnualId');
      document.body.appendChild(link);
      link.click();
      document.getElementById('relatorioCicloOrcamentarioPacotePluriAnualId').outerHTML = '';
    }),
  );
};
